
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M123.9 116.6L93.4 84.9c7.8-9.3 12.1-21 12.1-33.2C105.5 23.2 82.4 0 53.9 0S2.2 23.2 2.2 51.7s23.2 51.7 51.6 51.7c10.7 0 20.9-3.2 29.6-9.4l30.7 31.9c1.3 1.3 3 2.1 4.9 2.1 1.7 0 3.4-.7 4.7-1.9 2.7-2.6 2.7-6.8.2-9.5zm-70-103.1c21 0 38.2 17.1 38.2 38.2S74.9 89.9 53.9 89.9 15.7 72.7 15.7 51.7s17.1-38.2 38.2-38.2z"}})])
          )
        }
      }
    